import React, { useState, useEffect } from "react"
import clutchLogo from "../../../assets/images/icons/clutch/logo.svg"
import clutchStar from "../../../assets/images/icons/clutch/star.svg"
import clutchStarHalf from "../../../assets/images/icons/clutch/star_half.svg"

import "./styles.scss"

const Clutch = ({ rating, numberOfReviews }) => {
  const [roundedRating, setRoundedRating] = useState(0)

  useEffect(() => {
    setRoundedRating(Math.round(rating * 2) / 2)
  }, [])

  let x
  let stars = []

  if (roundedRating % 1 !== 0) {
    for (x = 0; x < Math.floor(roundedRating); x++) {
      stars.push(<img src={clutchStar} key={x} alt="Clutch star icon" />)
    }
    stars.push(<img src={clutchStarHalf} key={x} alt="Clutch star icon" />)
  } else {
    for (x = 0; x < roundedRating; x++) {
      stars.push(<img src={clutchStar} key={x} alt="Clutch star icon" />)
    }
  }

  return (
    <div className="clutch">
      <img src={clutchLogo} alt="Clutch logo image" className="clutch__logo" />
      <span className="clutch__rating">{rating.toFixed(1)}</span>
      <div className="clutch__stars">
        {stars} {numberOfReviews && <span>{numberOfReviews} reviews</span>}
      </div>
    </div>
  )
}

export default Clutch
